import RequestProgressService from 'requestProgress/RequestProgressService.ts';
import { DarkVenueMappingsApi } from 'widgets/darkVenueHeatmap/venueMappings/DarkVenueMappingsApi.ts';
import {
    buildLogger,
    Logger,
    LoggingService,
} from '@instinet-analytics/core-lib';
import { Store } from 'redux';
import { setDarkVenueMappings } from 'widgets/darkVenueHeatmap/venueMappings/darkVenueMappingsSlice.ts';

export class DarkVenueMappingsService {
    public store: Store | undefined;
    private requestProgressService: RequestProgressService;
    private api: DarkVenueMappingsApi;
    private logger: Logger;
    private fetchInvoked = false;

    public constructor({
        requestProgressService,
        api,
        loggingService,
    }: {
        requestProgressService: RequestProgressService;
        api: DarkVenueMappingsApi;
        loggingService: LoggingService;
    }) {
        this.requestProgressService = requestProgressService;
        this.api = api;
        this.logger = buildLogger('VenueMappingsService', loggingService);
    }

    public fetchMappings() {
        if (this.fetchInvoked) {
            return;
        }

        this.fetchInvoked = true;

        this.requestProgressService
            .invokeAndMonitorRequest('getDarkVenueMappings', (options) =>
                this.api.fetchMappings(options)
            )
            .then((data) => {
                this.logger.debug('Fetched dark venue mappings');
                this.store!.dispatch(setDarkVenueMappings(data));
            })
            .catch((err) => {
                this.logger.warn('Error fetching dark venue mappings', err);
            });
    }
}
